import React from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { configureStore, history } from './configureStore';
import { AtorchConsole } from './components/AtorchConsole';
const store = configureStore();
const Entry = () => (React.createElement(Provider, { store: store },
    React.createElement(ConnectedRouter, { history: history },
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: '/', component: AtorchConsole })))));
export default Entry;
